<template>
    <div class="steps">
        <div class="steps-flex flex align-cen ">
            <div class="steps-flex-list flex align-cen"
            v-for="(item, index) in list"
            :key="index"
            :class="{current:active == item.steps}"
            >
            <div class="zent-steps-step">
                {{item.steps}}. {{item.text}}
            </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
     name:'steps',
     props: {
    active: [String, Number],
    },
     data: () => {
        return {
        current:'current',
        list:[
            {
                steps:1,
                text:'编辑基本信息',
                title:'帮助课程的基本信息'
            },
            {
                steps:2,
                text:'章节编辑',
                title:'设定章节信息'
            },{
                steps:3,
                text:'上传内容',
                title:'上传帮助课程内容'
            }

        ]
        }
     },
     created (){

     },
     methods: {
        
     }
}
</script>
<style lang="scss" scoped>
.steps{
    margin:16px;
    height: 40px;
    .steps-flex{
       .steps-flex-list{
        width: 33.3%;
        padding: 0 8px;
    box-sizing: border-box;
    position: relative;
        .zent-steps-step{
            width: 100%;
         height: 48px;
        line-height: 48px;
        font-size: 14px;
        text-align: center;
        padding: 0 10px;
        background: #fff;
        color: #323233;
         box-sizing: border-box;
         position: relative;
        }
        // .num{
        //     width: 40px;
        //     height: 40px;
        //     line-height: 40px;
        //     border-radius: 40px;
        //     text-align: center;
        //     border: 1px solid #2C8CF0;
        //     color: #2C8CF0;
        //     margin-right: 20px;
        // }
        // .text{
        //     width: 120px;
        //     color: #B6B6B6;
        //     .tit2{
        //         font-size: 12px;
        //         padding-top: 20px;
        //     }
        // }
        // .line{
        //     height: 1px;
        //     background:#B6B6B6;
        //     width: 250px;
        //     margin-right: 50px;
        // }
      
       } 
       .steps-flex-list:last-child{
        padding-right: 0;
       }
       .steps-flex-list:last-child .zent-steps-step::after{
        content: none;
       }
       .zent-steps-step::before{
        border-top-color: #fff;
        border-bottom-color: #fff;
        content: " ";
    display: block;
    width: 0;
    height: 0;
    border-top-width: 24px;
    border-top-style: solid;
    border-bottom-width: 24px;
    border-bottom-style: solid;
    border-left: 12px solid transparent;
    position: absolute;
    top: 50%;
    margin-top: -24px;
    left: -12px;
       }
       .zent-steps-step::after{
        content: " ";
    display: block;
    width: 0;
    height: 0;
    border-top: 24px solid transparent;
    border-bottom: 24px solid transparent;
    border-left-width: 12px;
    border-left-style: solid;
    position: absolute;
    top: 50%;
    margin-top: -24px;
    right: -12px;
        border-left-color: #fff;
       }
       .current{
        .zent-steps-step{
            background-color: #155bd4;
            color: #fff;
        }
        .num{
            border: none;
            color: #fff;
            background: #2C8CF0;
        }
          .text{
            color: rgb(81, 90, 110);
        }
         .line{
            background:#2C8CF0;
        }
       }
       .steps-flex-list:first-child{
        padding-left: 0;
       }
       .steps-flex-list:first-child .zent-steps-step::before{
        content: none;
        
       }
       .current .zent-steps-step::before{
        border-top-color: #155bd4;
        border-bottom-color:#155bd4
       }
       .current .zent-steps-step::after{
        border-left-color:#155bd4;
        content: " ";
            display: block;
            width: 0;
            height: 0;
            border-top: 24px solid transparent;
            border-bottom: 24px solid transparent;
            border-left-width: 12px;
            border-left-style: solid;
            position: absolute;
            top: 50%;
            margin-top: -24px;
            right: -12px;
       }
    }
}
</style>